import { createContext } from "react";

import { CollectionPageContextType } from "./types";
import { defaultCollectionPageContextValue } from "./consts";

export const CollectionPageContext = createContext<CollectionPageContextType>(defaultCollectionPageContextValue);
